export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const timeOutSec = 30;
export const RES_PER_PAGE = 10;
export const KEY = 'd41991c7-8185-4dd7-bc72-9ba0b5a09397';
export const MODAL_CLOSE_SEC = 2.5;
